import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { ShipOwnerCompanyPayload, ShipOwnerCompanyResponse } from "@/types/interface/ship-owner-company";

async function createShipOwnerCompany(payload: ShipOwnerCompanyPayload) {
  return await http.post<APIResponse<ShipOwnerCompanyResponse>>("ship-owner-company/create", payload);
}

async function updateShipOwnerCompany(idPosition = '', payload: ShipOwnerCompanyPayload) {
  return await http.patch<APIResponse<ShipOwnerCompanyResponse>>(`ship-owner-company/update?id=${idPosition}`, payload);
}

async function getShipOwnerCompany(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<ShipOwnerCompanyResponse>>(`ship-owner-company?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findShipOwnerCompany(idPosition = "") {
  return await http.get<APIResponse<ShipOwnerCompanyResponse>>(`ship-owner-company/detail?id=${idPosition}`);
}

async function deleteShipOwnerCompany(idPosition = "") {
  return await http.delete<APIResponse<ShipOwnerCompanyResponse>>(`ship-owner-company/delete?id=${idPosition}`);
}

export default {
  createShipOwnerCompany,
  updateShipOwnerCompany,
  getShipOwnerCompany,
  findShipOwnerCompany,
  deleteShipOwnerCompany
};